import { render } from "./InlineMessageWidget.vue?vue&type=template&id=770a1e40&scoped=true"
import script from "./InlineMessageWidget.vue?vue&type=script&lang=js"
export * from "./InlineMessageWidget.vue?vue&type=script&lang=js"

import "./InlineMessageWidget.vue?vue&type=style&index=0&id=770a1e40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770a1e40"]])

export default __exports__